module.exports = __webpack_public_path__ + "img/pic_title.60fa66dd.svg";